import { observer } from 'mobx-react-lite'

import { StoreReturnsSettings, MsStoresLoadingProps } from '../StoreReturnsSettings'

import { useApi } from '../../../hooks/storeHook'
import { useYmAccount } from '../../../hooks/routeHooks'

export const YandexMarketReturnsSettings =
  observer(({msStores, loadMsStores}: MsStoresLoadingProps) => {
    const {userSync: {setYandexMarketReturnsSettings}} = useApi()
    const account = useYmAccount()

    return (
      <StoreReturnsSettings
        title="НАСТРОЙКИ ВОЗВРАТОВ"
        msStores={msStores}
        loadMsStores={loadMsStores}
        account={account}
        saveSettings={setYandexMarketReturnsSettings}
      />
    )
  })